import { Component, Input, OnInit } from '@angular/core';
import { PlatformEnum } from '@panamax/app-state';
import { ServiceRequestType, SousStatus } from '@usf/list-types';

@Component({
  selector: 'app-support-center-status',
  templateUrl: './support-center-status.component.html',
  styleUrls: ['./support-center-status.component.scss'],
})
export class SupportCenterStatusComponent {
  @Input() status: SousStatus;
  @Input() statusText: string;
  @Input() serviceRequestType: ServiceRequestType;
  @Input() platform: PlatformEnum;
  @Input() isResubmitting = false;
  @Input() isCard = true;

  platformRef = PlatformEnum;
  statusRef = SousStatus;
  requestRef = ServiceRequestType;
  constructor() {}
}
